import { MaintenanceSettings, TrackingSettings } from '@actiris/forms';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AppSettings, EnvironmentName } from '../models/app-settings';

@Injectable({
    providedIn: 'root',
})
export class AppSettingsService implements MaintenanceSettings, TrackingSettings {
    private static _settings: AppSettings;

    private http = inject(HttpClient);

    public get environmentName(): EnvironmentName {
        return this.settings.environment.name;
    }

    public get environmentClass(): string {
        return `act-environment-${this.settings.environment.name}`.toLocaleLowerCase();
    }

    public get securityUrl(): string {
        return this.settings.webApi.securityUrl;
    }

    public get startTimeUtc(): string {
        return this.settings.maintenance.startTimeUtc;
    }

    public get endTimeUtc(): string {
        return this.settings.maintenance.endTimeUtc;
    }
    public get startDateTime() {
        return this.settings.maintenance.startDateTime;
    }

    public get endDateTime() {
        return this.settings.maintenance.endDateTime;
    }

    public get maintenancePageUrl() {
        return this.settings.maintenance.maintenancePageUrl;
    }

    public get registerLockTimer(): number {
        return this.settings.maintenance.registerLockTimer;
    }

    public get warningLockTimer(): number {
        return this.settings.maintenance.warningLockTimer;
    }

    public get registrationUrls(): { jobseeker: string; employer: string } {
        return this.settings.registrationUrls;
    }

    public get trackingId(): string {
        return this.settings.analytics.trackingId;
    }

    public get settings(): AppSettings {
        return AppSettingsService._settings;
    }

    public get projectCode(): string {
        return this.settings.projectCode;
    }

    public GetVersion(): string {
        return `API v${this.settings.version.api} - UI v${this.settings.version.ui}`;
    }

    /**
     * Load configuration values in config.json file
     */
    public load(): Observable<AppSettings> {
        const jsonFile = `assets/config/appSettings.json`;
        return this.http.get<AppSettings>(jsonFile).pipe(
            tap((r) => {
                AppSettingsService._settings = r;
                // Display some info in Dev and Prod environment
                /* eslint-disable no-console */
                console.info('Application version: ' + this.GetVersion());
                if (environment.production === false) {
                    console.info('Security API URL: ' + this.securityUrl);
                    console.info('AppSettings.json: ', this.settings);
                }
            }),
        );
    }
}
